import React from 'react';

// @ts-ignore
import Icon from 'assets/images/trojanSvg/BaitGrey.svg';

interface BaitGreyProps {
  height: number;
}

const BaitGrey: React.FC<BaitGreyProps> = ({ height }) => {
  return <img src={Icon} height={height} alt="Bait Gray Icon" />;
};

export default BaitGrey;
